import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@nextui-org/react";
import AddressDividendAbi from "../../assets/abis/AddressDividend.json";
import { ad} from "../../constants";
import { readContracts } from "@wagmi/core";
import {  formatUnits, numberToBytes } from "viem";
import {  useConfig } from "wagmi";
import {  useCallback, useEffect, useState } from "react";



 function QuestionModal({isOpen, onOpenChange}) {
  const config = useConfig()

  const [number1, setNumber1] = useState(0);
        const fetch = 
      useCallback(async () => {
       const number1= await readContracts(config, {
          allowFailure: false,
          contracts: [
            {
              abi: AddressDividendAbi,
              address: ad[0],
              functionName: 'totalSupply'
            }
          ]
        });
        setNumber1(number1[0]);
      }, [config]);
      useEffect(() => {
    if (config ) {
      fetch()
    } else {
      setNumber1(0)
    }
  }, [fetch, config]);
  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
      <ModalContent>
        <ModalHeader className={'pb-2 font-medium'}>
          SWAP加权分红
        </ModalHeader>
        <ModalBody className={'gap-4'}>
         <div className="flex flex-col gap-4">
          <p className="text-sm text-gray-500">社区矿机100台以上可升级激活，获得全网分红</p>
                  <div className="bg-black flex-col justify-center " >
                           <div className="p-4 mlr-4 bg-gray-100 dark:bg-box text-center " >
                        <div className="flex justify-between" >
                          <div>
                            <p className="text-gray-400">社区矿机数量</p>
                          </div>
                          <div>
                            <p className="text-gray-400">预计分红</p>
                          </div>
                          <div>
                            <p className="text-gray-400">共享人数</p>
                          </div>
                        </div>
                      </div>
                      <div className="p-4 mlr-4 bg-gray-100 dark:bg-box text-center " >
                        <div className="flex justify-between" >
                          <div>
                            <p className=" font-bold">100台</p>
                          </div>
                          <div>
                            <p className=" font-bold">9900</p>
                          </div>
                          <div>
                            <p className=" font-bold">{Number(formatUnits(number1,18))}人</p>
                          </div>
                        </div>
                      </div>
                                          <div className="p-4 mlr-4 bg-gray-100 dark:bg-box text-center " >
                        <div className="flex justify-between" >
                          <div>
                            <p className=" font-bold">500台</p>
                          </div>
                          <div>
                            <p className=" font-bold">19800</p>
                          </div>
                          <div>
                            <p className=" font-bold">0人</p>
                          </div>
                        </div>
                      </div>
                  <div className="p-4 mlr-4 bg-gray-100 dark:bg-box text-center " >
                        <div className="flex justify-between" >
                          <div>
                            <p className=" font-bold">1000台</p>
                          </div>
                          <div>
                            <p className=" font-bold">29700</p>
                          </div>
                          <div>
                            <p className=" font-bold">0人</p>
                          </div>
                        </div>
                      </div>
                    <div className="p-4 mlr-4 bg-gray-100 dark:bg-box text-center " >
                        <div className="flex justify-between" >
                          <div>
                            <p className=" font-bold">2000台</p>
                          </div>
                          <div>
                            <p className=" font-bold">42900</p>
                          </div>
                          <div>
                            <p className=" font-bold">0人</p>
                          </div>
                        </div>
                      </div>
                  </div>
        </div>
        </ModalBody>

        <ModalFooter>

        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default QuestionModal